import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=7a2e97aa"
import script from "./ForgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports